<section class="panel cd-panel">
  <div class="panel-head">
    <h3 class="panel-title">Customer display</h3>
    <span class="pill pill-grey">Read-only</span>
  </div>

  @if (loading) {
    <p class="muted">Loading the customer display…</p>
  } @else if (loadError) {
    <div class="note note-err">{{ loadError }}</div>
  } @else if (settings) {
    <div class="cd-grid">
      <div class="cd-facts">
        <div class="cd-fact">
          <span class="cd-label">Layout</span>
          <span class="cd-value">{{ current.label }}</span>
          <span class="muted small">{{ source }}</span>
        </div>
        <div class="cd-fact">
          <span class="cd-label">Business name on screen</span>
          <span class="cd-value">{{ settings.businessName || '—' }}</span>
          @if (!settings.businessName) { <span class="muted small">Falls back to the business's own name</span> }
        </div>
        <div class="cd-fact">
          <span class="cd-label">Welcome message</span>
          <span class="cd-value">{{ settings.welcomeMessage || 'Welcome' }}</span>
          @if (!settings.welcomeMessage) { <span class="muted small">Default</span> }
        </div>
        <div class="cd-fact">
          <span class="cd-label">Thank-you message</span>
          <span class="cd-value">{{ settings.thankYouMessage || 'Thank you' }}</span>
          @if (!settings.thankYouMessage) { <span class="muted small">Default</span> }
        </div>
        <div class="cd-fact-row">
          <span>Savings shown: <strong>{{ settings.showSavings ? 'Yes' : 'No' }}</strong></span>
          <span>Fallback image: <strong>{{ settings.hasFallbackImage ? 'Set' : 'None' }}</strong></span>
        </div>
        @if (settings.updatedAt) {
          <span class="muted small">POS settings last saved {{ settings.updatedAt | date:'d MMM y, HH:mm' }}</span>
        }
        <p class="muted small">
          The business changes this in POS → Devices → Customer Display. Whether a till's
          second screen is a touch screen is set on each till and is not visible here.
        </p>
      </div>

      <div class="cd-preview">
        <app-customer-display-preview [layout]="current" [businessName]="settings.businessName"></app-customer-display-preview>
        <span class="muted small">{{ current.hint }}</span>
      </div>
    </div>

    <button type="button" class="act-ghost cd-toggle" (click)="toggleAll()" [attr.aria-expanded]="showAll">
      {{ showAll ? 'Hide other layouts' : 'Compare all layouts' }}
    </button>

    @if (showAll) {
      <div class="cd-gallery">
        @for (l of layouts; track l.value) {
          <div class="cd-tile" [class.current]="l.value === current.value">
            <app-customer-display-preview [layout]="l" [businessName]="settings.businessName"></app-customer-display-preview>
            <div class="cd-tile-caption">
              <strong>{{ l.label }}</strong>
              @if (l.value === current.value) { <span class="pill">In use</span> }
            </div>
          </div>
        }
      </div>
    }
  }
</section>
